import { Box } from '@udecode/plate-common';
import { TableElementCol } from './TableElementCol';
import { TableElementColGroup } from './TableElementColGroup';
import { TableElementRoot } from './TableElementRoot';
import { TableElementTBody } from './TableElementTBody';

export const TableElement = {
  Wrapper: Box,
  Root: TableElementRoot,
  Col: TableElementCol,
  ColGroup: TableElementColGroup,
  TBody: TableElementTBody,
};
